/* eslint-disable */
// @generated by protobuf-ts 2.9.4 with parameter ts_nocheck,add_pb_suffix,keep_enum_prefix,eslint_disable
// @generated from protobuf file "web_services/candidate_experience/proto/common.proto" (package "applied.candidate_experience", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message applied.candidate_experience.MarketConditions
 */
export interface MarketConditions {
    /**
     * @generated from protobuf field: int64 fair_market_value_usd_cents = 1;
     */
    fairMarketValueUsdCents: bigint;
    /**
     * @generated from protobuf field: int64 preferred_price_usd_cents = 2;
     */
    preferredPriceUsdCents: bigint;
    /**
     * @generated from protobuf field: float usd_cents_to_offer_subdivisions = 3;
     */
    usdCentsToOfferSubdivisions: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class MarketConditions$Type extends MessageType<MarketConditions> {
    constructor() {
        super("applied.candidate_experience.MarketConditions", [
            { no: 1, name: "fair_market_value_usd_cents", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "preferred_price_usd_cents", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "usd_cents_to_offer_subdivisions", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value?: PartialMessage<MarketConditions>): MarketConditions {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fairMarketValueUsdCents = 0n;
        message.preferredPriceUsdCents = 0n;
        message.usdCentsToOfferSubdivisions = 0;
        if (value !== undefined)
            reflectionMergePartial<MarketConditions>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MarketConditions): MarketConditions {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 fair_market_value_usd_cents */ 1:
                    message.fairMarketValueUsdCents = reader.int64().toBigInt();
                    break;
                case /* int64 preferred_price_usd_cents */ 2:
                    message.preferredPriceUsdCents = reader.int64().toBigInt();
                    break;
                case /* float usd_cents_to_offer_subdivisions */ 3:
                    message.usdCentsToOfferSubdivisions = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MarketConditions, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 fair_market_value_usd_cents = 1; */
        if (message.fairMarketValueUsdCents !== 0n)
            writer.tag(1, WireType.Varint).int64(message.fairMarketValueUsdCents);
        /* int64 preferred_price_usd_cents = 2; */
        if (message.preferredPriceUsdCents !== 0n)
            writer.tag(2, WireType.Varint).int64(message.preferredPriceUsdCents);
        /* float usd_cents_to_offer_subdivisions = 3; */
        if (message.usdCentsToOfferSubdivisions !== 0)
            writer.tag(3, WireType.Bit32).float(message.usdCentsToOfferSubdivisions);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message applied.candidate_experience.MarketConditions
 */
export const MarketConditions = new MarketConditions$Type();
